export const LANDING_GET_CAMPAIGNS = 'LANDING_GET_CAMPAIGNS';
export const LANDING_GET_CAMPAIGN_DETAIL = 'LANDING_GET_CAMPAIGN_DETAIL';
export const LANDING_UPDATE_CAMPAIGNS = 'LANDING_UPDATE_CAMPAIGNS';
export const LANDING_GET_STATIC_CONTENT = 'LANDING_GET_STATIC_CONTENT';
export const LANDING_UPDATE_STATIC_CONTENT = 'LANDING_UPDATE_STATIC_CONTENT';
export const LANDING_GOTO_CONTRACT = 'LANDING_GOTO_CONTRACT';
export const LANDING_SEND_SUGGESTION = 'LANDING_SEND_SUGGESTION';
export const LANDING_PROMOCODE = 'LANDING_PROMOCODE';
export const GET_FILTERS = 'GET_FILTERS';
export const GET_UPDATE_FILTERS = 'GET_UPDATE_FILTERS';
export const CAMPAIGN_PARENT_ID = 'CAMPAIGN_PARENT_ID';
export const PARTNERS_NO_CONTRACT = 'PARTNERS_NO_CONTRACT';
